import * as moment from 'moment';

import { TimeUnit, DayOfWeek } from '../../../models';
import { IAlignmentStrategy } from './IAlignmentStrategy';

export class DayAlignmentStrategy implements IAlignmentStrategy {
    align(
        input: moment.Moment,
        beginTime: moment.Duration,
        interval: number,
        intervalTimeUnit: TimeUnit,
        dayOfWeek: DayOfWeek
    ): moment.Moment {

        if (intervalTimeUnit === TimeUnit.Day) {
            const nextStartingDay = moment(input.toISOString())
                .hours(beginTime.hours())
                .minutes(beginTime.minutes())
                .seconds(0);

            // iterate adding one day to find the next starting day
            while (nextStartingDay.isBefore(input)) {
                nextStartingDay.add(1, 'day');
            }

            return nextStartingDay;
        }

        return null;
    }
}